import React from "react";
import { useField, useFormikContext } from "formik";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Tooltip from "@material-ui/core/Tooltip";
import { Typography } from "@material-ui/core";
import { useEffect } from "react";

function OptionField({
  label,
  name,
  fieldName,
  options,
  width,
  tooltip,
  required,
  disabled,
  initialValue,
  highlightName
}) {
  const nameOptionField =
    fieldName !== undefined ? `${name}.${fieldName}` : `${name}`;
  const [field, meta, helpers] = useField(nameOptionField);
  const { setFieldValue } = useFormikContext();

  useEffect(() => {
    if (initialValue !== undefined && !field.value) {
      setFieldValue(nameOptionField, initialValue, false);
    }
  }, [initialValue, field.value, nameOptionField, setFieldValue]);

  const currentValue =
    typeof field.value === "object" ? field.value.name : field.value || "";

  // Determine if the current value is valid (exists in options)
  const isValidValue = options.some((option) => option.value === currentValue);

  // Automatically reset value if it is invalid
  useEffect(() => {
    if (!isValidValue && currentValue) {
      setFieldValue(nameOptionField, undefined, false);
    }
  }, [currentValue, isValidValue, nameOptionField, setFieldValue]);

  return (
    <div className="flex">
      <div name={highlightName ? highlightName : nameOptionField} className={`${width} rounded-lg relative border min-w-[178px]`}>
        <FormControl fullWidth>
          <InputLabel>{label}</InputLabel>
          <Select
            {...field}
            value={isValidValue ? currentValue : ""}
            onChange={(event) => {
              const selectedOption = options.find(
                (option) => option.value === event.target.value
              );

              helpers.setValue(
                selectedOption?.id !== undefined
                  ? { name: selectedOption.value, id: selectedOption.id }
                  : selectedOption?.value || ""
              );
            }}
            label={label}
            size="small"
            disabled={disabled}
            error={meta.touched && !!meta.error}
          >
            {options.map((option, index) => (
              <MenuItem key={index} value={option.value} id={option.id}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      {required && (
        <div className="ml-1 text-accent">
          <Tooltip
            title={
              <Typography style={{ color: "white", fontSize: 13 }}>
                This field is required and cannot be left blank or unset
              </Typography>
            }
            arrow
          >
            <span>*</span>
          </Tooltip>
        </div>
      )}
      {tooltip && (
        <div className="ml-1 -mt-1">
          <Tooltip
            title={
              <Typography style={{ color: "white", fontSize: 13 }}>
                {tooltip}
              </Typography>
            }
            arrow
          >
            <span>?</span>
          </Tooltip>
        </div>
      )}
    </div>
  );
}

export default OptionField;
